import { Inject, Injectable } from '@angular/core';
import { DwOrmDataService, DwOrmDataServiceToken } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AppMetaData, ChallengeTeamMemberEntity, RoUserDonationsEntity } from '../../../meta-data/app-meta-data.service';
import { CentralDataService } from './central-data.service';
export interface StreakerDonation { userId: number; amount: number; }
/** The donation view repeats order lines for each team membership. Deduplicate before ranking. */
export function donationStandings(rows: RoUserDonationsEntity[]): StreakerDonation[] {
    const lines = new Set<string>(), totals = new Map<number, number>();
    for (const row of rows) {
        const anonymous = row.UserId === 0 && row.OrderDetailId === -1;
        if ((!anonymous && (!(row.UserId > 0) || !(row.OrderDetailId > 0))) || !Number.isFinite(row.DonationAmount) || row.DonationAmount <= 0) { continue; }
        const key = `${row.UserId}:${row.OrderDetailId}`;
        if (lines.has(key)) { continue; } lines.add(key);
        totals.set(row.UserId, (totals.get(row.UserId) || 0) + row.DonationAmount);
    }
    return Array.from(totals, ([userId, amount]) => ({userId, amount})).sort((a, b) => b.amount - a.amount || a.userId - b.userId);
}
@Injectable({ providedIn: 'root' })
export class StreakerDirectoryService {
    constructor(@Inject(DwOrmDataServiceToken) private _orm: DwOrmDataService, private _data: CentralDataService) {}
    donations(challengeId: number): Observable<StreakerDonation[]> {
        const query = AppMetaData.RoUserDonations.CreateQueryBuilder()
            .addFields(a => [a.UserId, a.OrderDetailId, a.DonationAmount])
            .addFilterAnd(f => f.Equal(a => a.ChallengeDefinitionId, challengeId));
        return this._data.snapshot(`streaker-donations:${challengeId}`, () =>
            this._orm.executeQuery<RoUserDonationsEntity>(query).pipe(map(donationStandings)));
    }
    teammates(enrollmentId: number): Observable<number[]> {
        if (!enrollmentId) { return of([]); }
        return this._data.memberships(enrollmentId).pipe(take(1), switchMap(own => {
            const ids = Array.from(new Set(own.map(row => row.ChallengeTeamId)));
            if (!ids.length) { return of([]); }
            const query = AppMetaData.ChallengeTeamMember.CreateQueryBuilder()
                .addFields(a => [a.UserChallengeId])
                .addFilterAnd(f => f.InList(a => a.ChallengeTeamId, ids));
            return this._orm.executeQuery<ChallengeTeamMemberEntity>(query).pipe(map(rows =>
                Array.from(new Set(rows.map(row => row.UserChallengeId).filter(id => id !== enrollmentId)))));
        }));
    }
}
